import { createContext, useContext } from 'react';

import type { FilterState } from '@/store/slices/filtersSlice';

/**
 * The filters widgets query with: the store's filters, debounced 300ms so a
 * burst of chip clicks makes one round of requests instead of twelve.
 */
export const AppliedFiltersContext = createContext<FilterState | null>(null);

export function useAppliedFilters(): FilterState {
  const value = useContext(AppliedFiltersContext);
  if (!value) throw new Error('useAppliedFilters must be used under <DataSourceLayout>.');
  return value;
}
